<!-- <mat-toolbar class="mat-elevation-z8"> -->
<div class="mobi-sec-footer">
  <ul class="mobi-sec-footer-list" id="footer-height">
    <li>
      <a class="footer-menu-link" routerLink="/dashboard" routerLinkActive="active" #rla="routerLinkActive" (click)="closeSidenav()">
        <span class="mobi-foot-image"><mat-icon>home</mat-icon> </span>
        <span class="mobi-foot-name">HOME</span>
      </a>
    </li>
    <li>
      <a class="footer-menu-link" routerLink="/category" routerLinkActive="active" #rla="routerLinkActive" (click)="closeSidenav()">
        <span class="mobi-foot-image port-lst-image"><mat-icon>grid_view</mat-icon></span>
        <span class="mobi-foot-name">Categories</span>
      </a>
    </li>
    <li>
      <a class="footer-menu-link" routerLink="/my-account" routerLinkActive="active" #rla="routerLinkActive" (click)="closeSidenav()">
        <span class="mobi-foot-image orders-lst-image"><mat-icon>account_circle</mat-icon></span>
        <span class="mobi-foot-name">You </span>
      </a>
    </li>

    <li>
      <a class="footer-menu-link" (click)="cartFun()" routerLinkActive="active" #rla="routerLinkActive" (click)="closeSidenav()">
        <span class="mobi-foot-image orders-lst-image">
          <mat-icon id="cartIconTarget">shopping_cart</mat-icon>
        </span>
        <label class="cart-badge" *ngIf="showQuantity">{{itemQuantity}}</label>

        <span class="mobi-foot-name mr-3">Cart </span>
      </a>
    </li>
  </ul>
</div>
<div class="overlay"></div>

<div class="scripsoverlay"></div>
<!-- </mat-toolbar> -->